import React, { useState, useEffect } from 'react';
import {
  StyledFooter,
  StyledFooterSpacer,
  StyledHorizontalBar,
  koreaLegalFooterDivider,
  minimalFooterClass,
} from './styles';
import FooterMenu from '../FooterMenu';
import SubFooter from '../SubFooter';
import { GLOBAL_NAV_KOREAN_FOOTER, MINIMAL_FOOTER_EXPERIENCES, NIKE_AI } from '../../constants';
import KoreanLegalFooter from '../KoreanLegalFooter';
import useFeatureFlags from '../../utils/hooks/featureFlagsHook';
import { LanguageMenuContent } from '../LanguageMenu';
import { useNavOptionsContext } from '../../context/optionsContext';
import NikeAIVariantB from '../NikeAIVariantB';

const Footer = () => {
  const isKorea = useFeatureFlags(GLOBAL_NAV_KOREAN_FOOTER);
  const isNikeAiEnabled = useFeatureFlags(NIKE_AI);
  const { opts } = useNavOptionsContext();
  const minimalFooterEnabled = MINIMAL_FOOTER_EXPERIENCES.includes(opts?.appInfo?.viewChannel);

  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  return (
    <>
      <StyledFooter className={minimalFooterEnabled && minimalFooterClass} role="contentinfo">
        <StyledHorizontalBar />
        <FooterMenu />
        <StyledFooterSpacer className="footer-spacer" />
        <SubFooter />
        {isKorea && (
          <>
            <StyledHorizontalBar className={koreaLegalFooterDivider} />
            <KoreanLegalFooter />
          </>
        )}
        {/* adding this here so the lang menu links are rendered for SEO purposes */}
        <LanguageMenuContent />
      </StyledFooter>

      {isClient && isNikeAiEnabled && <NikeAIVariantB />}
    </>
  );
};

export default Footer;
